import styled from "@emotion/styled"
import Link from "components/Link"

const ArticleAsideTabsItem = styled(Link)`
  display: flex;
  border-radius: 30px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.common.black};
  text-decoration: none;
  padding: 5px 20px;
  font-size: 18px;
  line-height: 22px;

  &:hover {
    background: #e3e3ec;
  }
`

export default ArticleAsideTabsItem
